import { render } from "./measurementview.vue?vue&type=template&id=c2b6fb3a&scoped=true"
import script from "./measurementview.vue?vue&type=script&lang=js"
export * from "./measurementview.vue?vue&type=script&lang=js"

import "./measurementview.vue?vue&type=style&index=0&id=c2b6fb3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b6fb3a"]])

export default __exports__